<template>
  <div class="job-summary position-relative p-3">
    <ul class="list-unstyled mb-0">
      <li>
        {{ 'ACTION' | translate }}:
        <span class="font-weight-bold">{{ jobType | translate('action') }}</span>
      </li>
      <li>
        {{ 'PRODUCT_LINE' | translate }}: 
        <div v-if="jobType === 'IMPORT_NVGA2'">
          <template v-if="productLineName">
             <li v-for="(line, index) in allProductLines" :key="index">
             <input type="checkbox" v-model="selectedLines" :value="line.name" :id="'line' + index"
             :disabled="!line.enabled || jobStatus === 'COMPLETE'" @change="emitSelectedLines">
             <label :for="'line' + index"> {{ line.description | translate('product') }}
             <span v-if="jobStatus !== 'COMPLETE'">[{{ line.count }}]</span>
             </label>
            </li>
          </template>
        </div>
      <div v-else>
         <span class="font-weight-semibold" v-if="productLineName">{{ getDescriptionByName(productLineName) }}</span>
         <span class="font-weight-semibold" v-else>-</span>
       </div>
      </li>
<li>
  {{ 'BATCH' | translate }}:
  <span class="font-weight-semibold" v-if="batchId">{{ batchId }}</span>
  <span class="font-weight-semibold" v-else>-</span>
</li>
<li v-if="policyCasesStatus">
  {{ 'POLICY_CASE_STATUS' | translate }}:
  <span class="font-weight-semibold">{{ policyCasesStatus | translate('status') }}</span>
</li>
</ul>
<div class="job-summary-icon text-center">
  <i v-if="productLineName !== 'HOUSECOMBI'" class="fa" :class="iconClassBasedOnProductLine"></i>
  <template v-else>
    <i class="fa fa-home"></i><i class="fa fa-fire-extinguisher"></i>
  </template>
  <strong class="d-block" :class="countClassBasedOnJobStatus">
    {{ rowsSuccess }} / {{ rowsTotal }}
  </strong>
</div>
</div>
</template>

<script>
import RestService from '../../service/RestService.js';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  props: ['jobType', 'jobStatus', 'productLineName', 'batchId', 'policyCasesStatus', 'rowsSuccess', 'rowsTotal'],
  data: function () {
    return {
      rest: this.initRestService(),
      selectedLines: [],
      enabledProductLines: []
    }
  },
  async beforeMount() {
    await this.init();
  },
  computed: {
    iconClassBasedOnProductLine() {
      switch (this.productLineName) {
        case 'HOUSECONTENT':
          return 'fa-home';
        case 'HOUSEFIRE':
          return 'fa-fire-extinguisher';
        case 'LIABILITY':
          return 'fa-user';
        case 'PASSENGERCAR':
          return 'fa-car';
        case 'HEARINGAID':
          return 'fa-deaf';
        case 'TRAVEL':
          return 'fa-suitcase';
        default:
          return 'fa-list';
      }
    },
    countClassBasedOnJobStatus: function () {
      switch (this.jobStatus) {
        case 'COMPLETE':
          return 'text-success';
        case 'RUNNING':
          return 'text-info';
        case 'PAUSED':
        case 'PENDING':
          return 'text-primary';
        case 'CANCELED':
        case 'EXPIRED':
          return 'text-warning';
        case 'FAILED':
        case 'VALIDATION_FAILED':
          return 'text-danger';
      }
    },
    productLineCounts() {
      const lineCounts = this.productLineName.split(',')
        .map(line => line.trim())
        .reduce((counts, line) => {
          counts[line] = (counts[line] || 0) + 1;
          return counts;
        }, {});
      return lineCounts;
    },
    enabledProductLineSet() {
      return new Set(this.enabledProductLines.map(item => ({
        name: item.name.trim(),
        description: item.description.trim()
      })));
    },
    allProductLines() {
      console.log(this.enabledProductLines);
      return Object.entries(this.productLineCounts)
        .map(([name, count]) => ({
          name,
          count,
          description: this.getDescriptionByName(name),
          enabled: this.enabledProductLineSet.has(name)
        }));
    }
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async init() {
      this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
    },
    emitSelectedLines() {
      this.$emit('update:selectedLines', this.selectedLines.slice());
    },
    getDescriptionByName(name) {
      for (let item of this.enabledProductLineSet) {
        if (item.name === name) {
          return item.description;
        }
      }
      return '-';
    }
  }
}
</script>

<style lang="scss" scoped>
.job-summary {
  font-size: 1.3em;
  background-color: #EBEBEB;

  ul li {
    min-height: 20px;

    +li {
      margin-top: 8px;
    }
  }
}

.job-summary-icon {
  position: absolute;
  top: 50%;
  right: 30px;
  font-size: 1.8rem;
  color: #B1B1B1;
  transform: translateY(-50%);
}

.job-summary-icon strong {
  font-size: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/job/JobDetailsSummary.vue